import React from 'react';
import { ClipboardCheckIcon, BookOpenIcon, TrophyIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function FeaturesSection() {
  return <section id="how-it-works" className="w-full bg-white py-16 md:py-24 border-t border-gray-200" data-id="element-175">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-176">
        <div className="text-center mb-16" data-id="element-177">
          <h2 className="text-[1.625rem] md:text-[2.5rem] font-semibold text-[#111111] leading-[1.2] mb-6" data-id="element-178">
            Three steps to a family that's actually protected
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-179">
          {/* Step 1: Assess */}
          <div className="bg-[#f8f8f8] rounded-2xl p-8 border-2 border-gray-200 text-center relative" data-id="element-180">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#631bb7] text-white w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm" data-id="element-181">
              1
            </div>
            <div className="w-16 h-16 bg-[#631bb7] bg-opacity-5 rounded-2xl flex items-center justify-center mx-auto mb-6 border border-[#631bb7] border-opacity-10" data-id="element-182">
              <ClipboardCheckIcon className="w-8 h-8 text-[#631bb7]" data-id="element-183" />
            </div>
            <h3 className="text-xl md:text-[1.75rem] font-semibold text-[#111111] leading-[1.3] mb-4" data-id="element-184">
              See Where You Stand
            </h3>
            <p className="text-base text-gray-600 leading-relaxed" data-id="element-185">
              Answer a few plain-English questions about your household. In 3
              minutes, you'll know exactly what's been left undone — and what to
              tackle first.
            </p>
          </div>

          {/* Step 2: Guide */}
          <div className="bg-[#f8f8f8] rounded-2xl p-8 border-2 border-gray-200 text-center relative" data-id="element-186">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#631bb7] text-white w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm" data-id="element-187">
              2
            </div>
            <div className="w-16 h-16 bg-[#631bb7] bg-opacity-5 rounded-2xl flex items-center justify-center mx-auto mb-6 border border-[#631bb7] border-opacity-10" data-id="element-188">
              <BookOpenIcon className="w-8 h-8 text-[#631bb7]" data-id="element-189" />
            </div>
            <h3 className="text-xl md:text-[1.75rem] font-semibold text-[#111111] leading-[1.3] mb-4" data-id="element-190">
              Get Guided
            </h3>
            <p className="text-base text-gray-600 leading-relaxed" data-id="element-191">
              Caveo walks each person through the actions that matter — step by
              step, in plain English — until they're done. No tech knowledge
              needed.
            </p>
          </div>

          {/* Step 3: Empower */}
          <div className="bg-[#f8f8f8] rounded-2xl p-8 border-2 border-gray-200 text-center relative" data-id="element-192">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#631bb7] text-white w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm" data-id="element-193">
              3
            </div>
            <div className="w-16 h-16 bg-[#631bb7] bg-opacity-5 rounded-2xl flex items-center justify-center mx-auto mb-6 border border-[#631bb7] border-opacity-10" data-id="element-194">
              <TrophyIcon className="w-8 h-8 text-[#631bb7]" data-id="element-195" />
            </div>
            <h3 className="text-xl md:text-[1.75rem] font-semibold text-[#111111] leading-[1.3] mb-4" data-id="element-196">
              Stay Safe
            </h3>
            <p className="text-base text-gray-600 leading-relaxed" data-id="element-197">
              Caveo keeps everyone on track with ongoing check-ins and reminders
              so safe habits stick and nothing important gets missed. No more
              being the family's IT person.
            </p>
          </div>
        </div>

        <div className="text-center" data-id="element-198">
          <Link to="/onboarding" className="bg-[#631bb7] text-white px-8 py-4 rounded-lg font-medium text-sm inline-flex items-center justify-center no-underline hover:bg-[#521099] transition-all shadow-md" data-id="element-199">
            Get Started
          </Link>
        </div>
      </div>
    </section>;
}